import { createApp } from 'vue'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import App from './App.vue'
// import './registerServiceWorker'
import router from './router';
import '@fortawesome/fontawesome-free/css/all.min.css';
import './styles/admin-shell.css';

const app = createApp(App)

app.use(router)
app.use(ElementPlus)

/**
 * 是否为生产构建（npm run build）；开发调试（npm run serve）为 false
 * @type {boolean}
 */
const isProduction = process.env.NODE_ENV === 'production'

/**
 * 后端 API 根地址：本地调试走本机，打包上线走正式域名
 * @type {string}
 */
const apiBaseUrl = isProduction ? 'https://api.terracode.cn' : 'https://api.terracode.cn'

// 使用 provide 提供全局数据
app.provide('serverUrl', apiBaseUrl)
app.provide('fileUrl', apiBaseUrl)
/** 文件上传接口 /api/upload/file 所需的请求头 apikey（与后端 FileUploadController 校验一致） */
app.provide('uploadApiKey', '37A3285C065822FA75B791F14AC9AE40')
app.mount('#app')
